import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { LectionaryTrack } from '../components/lectionary-track/lectionary-track.component';

@Injectable()
export class LectionaryTrackService {
 
  private cache: LectionaryTrack[];

  constructor(private apiSvc: ApiService) { }

  public loadEntites(): Promise<LectionaryTrack[]> {

    const p = new Promise<LectionaryTrack[]>((resolve, reject) => {

      if (this.cache && this.cache.length > 0) {
        console.log("FeastType cache detected");
        resolve(this.cache);
        return;
      }

      this.apiSvc.get("api/LectionaryTrack", null).subscribe(
        (data: LectionaryTrack[]) => {
          console.log(data);
          this.cache = data;
          resolve(this.cache);
        },
        (err) => {
          console.log("error", err);
        }
      );

  });

  return p;

}

public getItem(itemId: number): Promise<LectionaryTrack> {

  const p = new Promise<LectionaryTrack>((resolve, reject) => {

    this.apiSvc.get("api/LectionaryTracks/GetItem/" + itemId, null).subscribe(
      (data: LectionaryTrack) => {
        console.log("LectionaryTrack/GetItem", data);
        resolve(data);
      },
      (err) => {
        console.log("error", err);
      }
    );

  });

  return p;
}

  public save(model: LectionaryTrack): Promise<LectionaryTrack> {

    const p = new Promise<LectionaryTrack>((resolve, reject) => {

      this.apiSvc.post("api/LectionaryTracks/save", model).subscribe(
        (data: LectionaryTrack) => {
            resolve(data);
        },
        (err) => {
          console.log("error", err);
        //  this.isLoading = false;
 
        }
      );

    });

  return p;
  }
}
